import { Injectable, Component, EventEmitter, Type } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GenericResponse } from '@otas/model/genericResponse';
import { AppModalService } from '@otas/shared/ui/app-modal/app-modal.service';

/** Loosely-typed view over AppModalRef with the legacy NgbModalRef result
 *  typing (Promise<any>) so existing call sites compile unchanged. */
export interface PunchangModalRef {
  componentInstance: any;
  result: Promise<any>;
  close(value?: unknown): void;
  dismiss(reason?: unknown): void;
}

@Injectable({
  providedIn: 'root'
})
export class PuchangamModalService {
  panchangModalEvent = new EventEmitter()
  constructor(private appModal: AppModalService, private http: HttpClient) { }
  /**
   * Opens the panchang calendar view in an AppModal card (centered CDK
   * overlay) instead of the legacy root NgbModal. The view brings its own
   * chrome (toolbar + close button), so the card is opened chrome-less; the
   * AppModal NgbActiveModal bridge keeps the view's activeModal.close()
   * contract unchanged. Esc handling lives in the view (cancel-close), so
   * keyboard dismissal here stays off like the legacy backdrop:'static'.
   */
  openPunchangModal(component: Component, holidays, pooja, title?, keyboard?): PunchangModalRef {
    const modalRef = this.appModal.open(component as unknown as Type<unknown>, {
      size: 'xl', showClose: false, keyboard: false, modalClass: 'pcv-modal',
    }) as unknown as PunchangModalRef;
    const instance: any = modalRef.componentInstance;
    instance.holidays = holidays;
    instance.pooja = pooja;
    instance.title = title;
    instance.keyboard = keyboard;
    return modalRef;
  }
  getBookedDates(id, date?): Observable<GenericResponse<any[]>> {
    const url = date ? `pooja/booked/dates/online${id}/${date}` : `pooja/booked/dates/${id}`;
    return this.http.get<GenericResponse<any[]>>(url);
  }
}
